<script lang="ts">
  // Altitude over the ride as a soft filled profile.
  export let alt: (number | null)[]
  export let width = 936
  export let height = 120
  export let color = 'currentColor'
  export let opacity = 0.35

  const uid = Math.random().toString(36).slice(2, 8)

  $: vals = alt.map((v) => (typeof v === 'number' ? v : null))
  $: defined = vals.filter((v): v is number => v !== null)
  $: min = defined.length ? Math.min(...defined) : 0
  $: max = defined.length ? Math.max(...defined) : 1
  // Keep flat rides looking flat: at least 60 m of range.
  $: range = Math.max(max - min, 60)
  $: d = vals.length > 1
    ? `M0,${height}` + vals.map((v, i) => {
        const px = (i / (vals.length - 1)) * width
        const py = height - (((v ?? min) - min) / range) * (height - 6) - 3
        return `L${px.toFixed(1)},${py.toFixed(1)}`
      }).join('') + `L${width},${height}Z`
    : ''
</script>

{#if d}
  <svg {width} {height} viewBox="0 0 {width} {height}" class="xr-elev" aria-hidden="true">
    <defs>
      <linearGradient id="elev-{uid}" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" style="stop-color: {color}" stop-opacity={opacity} />
        <stop offset="1" style="stop-color: {color}" stop-opacity={opacity * 0.15} />
      </linearGradient>
    </defs>
    <path {d} fill="url(#elev-{uid})" />
  </svg>
{/if}

<style>
  .xr-elev {
    display: block;
  }
</style>
